import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var checkedCheckboxIcon =
/*#__PURE__*/
// eslint-disable-next-line react/forbid-elements
_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9.222 7.463",
  width: "9",
  height: "7",
  children: /*#__PURE__*/_jsx("path", {
    fill: "#FFF",
    d: "M3.062 6.86l.745.603.633-.72 4.782-5.42L7.722 0 3.507 4.78 1.26 2.83 0 4.387 3.062 6.86z"
  })
});